import React from 'react';
import type { DeletedExperimentSessionItem } from '@/types';

export function useDeletedSessionsSorting(sessions: DeletedExperimentSessionItem[]) {
  const [sortDescriptor, setSortDescriptor] = React.useState<{
    column: keyof DeletedExperimentSessionItem;
    direction: 'ascending' | 'descending';
  } | null>(null);

  const sortedSessions = React.useMemo(() => {
    if (!sortDescriptor) return sessions;

    const { column, direction } = sortDescriptor;

    return [...sessions].sort((a, b) => {
      const aValue = a[column];
      const bValue = b[column];

      if (aValue === null || aValue === undefined) return 1;
      if (bValue === null || bValue === undefined) return -1;

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        const comparison = aValue.localeCompare(bValue);
        return direction === 'ascending' ? comparison : -comparison;
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        const comparison = aValue - bValue;
        return direction === 'ascending' ? comparison : -comparison;
      }

      return 0;
    });
  }, [sessions, sortDescriptor]);

  return {
    sortDescriptor,
    setSortDescriptor,
    sortedSessions
  };
}
